import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Product } from "../models/Product";

interface UseDeleteProductReturn {
  fetch: Omit<UseFetchResult<Product, Product>, "fetchData"> & {
    fetchData: (id: string | number) => Promise<Product | null>;
  };
}

export const useDeleteProduct = (): UseDeleteProductReturn => {
  const { fetchData, ...rest } = useFetch<Product, Product>("/api/products", {
    skipInitialFetch: true,
    method: "delete",
    withToast: {
      loading: "Deleting product...",
      success: "Product deleted successfully!",
      error: "Failed to delete product.",
    },
  });

  const deleteById = (id: string | number) =>
    fetchData({ url: `/api/products/${id}` });

  return {
    fetch: {
      ...rest,
      fetchData: deleteById,
    },
  };
};
